// Animation.js
export const cardVariants = {
  offscreen: {
    x: -50,
    opacity: 0,
  },
  onscreen: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 50,
      damping: 10,
      duration: 0.8,
    },
  },
};

export const cardVariantYs = {
  offscreen: {
    y: 100,
    opacity: 0,
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0.2,
      duration: 1,
    },
  },
};

export const specialPaths = [
  "/admission",
  "/actualite",
  "/engagements",
  "/valeurs",
  "/contact",
  "/pdg",
  "/about",
  "/prepa-gd",
  "/prepa-hybride",
  "/autre-formation",
  "/autre-service",
  "/campus",
  "/espace-etudiant",
  "/curriculum",
];
